import type { AtcProduct } from "@/types/atc";

export const LP_MONTHLY_QUERY = "lp-monthly";

export type SearchParamsRecord = { [key: string]: string | string[] | undefined };

export const isLpMonthlyParam = (searchParams?: SearchParamsRecord | null): boolean => {
  const value = searchParams?.[LP_MONTHLY_QUERY];
  if (Array.isArray(value)) {
    return value.includes("true");
  }
  return value === "true";
};

export const isLpMonthlySearch = (search: string): boolean => {
  const query = search.startsWith("?") ? search.slice(1) : search;
  return isLpMonthlyParam({ [LP_MONTHLY_QUERY]: new URLSearchParams(query).get(LP_MONTHLY_QUERY) });
};

export const isLpMonthlyInBrowser = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return isLpMonthlySearch(window.location.search);
};

export const cloneWithFirstOptionSku = (products: AtcProduct[]): AtcProduct[] =>
  products.map((product) => ({
    ...product,
    optionSkus: product.optionSkus.slice(0, 1),
    options: product.options?.slice(0, 1),
    ...(product.optionImages ? { optionImages: product.optionImages.slice(0, 1) } : {}),
  }));
